import type { FC } from 'react'

import { Document, Page, Text } from '@react-pdf/renderer'

import type { FormattedAudit } from '../export-prospect-audit/types'
import { OfAuditBlock } from './of-audit-block/OfAuditBlock'
import { ReportHeader } from './report-header/ReportHeader'
import { SocialAuditBlock } from './social-audit-block/SocialAuditBlock'
import { styles } from './styles'

interface Props {
  data: FormattedAudit
}

export const PdfReport: FC<Props> = ({ data }) => {
  if (!data.info?.id) {
    return null
  }

  return (
    <Document>
      <Page style={styles.page}>
        <Text style={styles.pageTitle}>Prospect Report</Text>
        <ReportHeader data={data.info} />
        {data.onlyfans.map((item) => (
          <OfAuditBlock
            key={item.accountUrl}
            data={item}
          />
        ))}
        {[...data.instagram, ...data.tiktok].map((item) => (
          <SocialAuditBlock
            key={item.accountUrl}
            data={item}
          />
        ))}
      </Page>
    </Document>
  )
}
